/**
 * The model, and the AI connection it runs through (spec 222): an organization can
 * have several connections, and two profiles on one model may reach it through
 * different ones. Drawn by a profile card's header and by a By workflow profile line.
 */
export function ModelLine({
  model,
  connectionName,
}: {
  model: string;
  connectionName?: string;
}) {
  return (
    <p className="flex flex-wrap items-baseline gap-x-1.5 text-sm break-words">
      <span className="font-medium">{model}</span>
      {connectionName && (
        <span className="text-muted-foreground text-xs">{`via ${connectionName}`}</span>
      )}
    </p>
  );
}
